import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import LinearProgressWithLabel from "components/LinearProgressWithLabel";
import { useTheme } from "@mui/styles";

export default function LoadingModal({ open, handleClose, uploadProgress }) {
  const theme = useTheme();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
          sx: {
            backgroundColor: "rgba(250, 250, 250, 0.05)",
            backdropFilter: "blur(2px)",
          },
        },
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: `1px ${theme.palette.primary.main} #000`,
            borderRadius: 1,
            boxShadow: 2,
            padding: theme.spacing(2, 4),
          }}
        >
          {uploadProgress < 100 && (
            <>
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontSize: theme.spacing(3),
                  display: "flex",
                  alignItems: "left",
                  justifyContent: "left",
                  "& .dot": {
                    animation: "dot-blink 1s infinite step-start",
                  },
                  "& .dot:nth-of-type(1)": {
                    animationDelay: "0s",
                  },
                  "& .dot:nth-of-type(2)": {
                    animationDelay: "0.1s",
                  },
                  "& .dot:nth-of-type(3)": {
                    animationDelay: "0.2s",
                  },
                  "@keyframes dot-blink": {
                    "0%, 20%, 100%": {
                      opacity: 0,
                    },
                    "40%": {
                      opacity: 1,
                    },
                  },
                }}
              >
                Uploading
                <Box className="dot">.</Box>
                <Box className="dot">.</Box>
                <Box className="dot">.</Box>
              </Typography>
              <Box sx={{ margin: theme.spacing(0, 0, 1, 0) }}>
                <LinearProgressWithLabel
                  theme={theme}
                  value={uploadProgress || 0}
                />
              </Box>
            </>
          )}
          {uploadProgress === 100 && (
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              sx={{
                fontSize: theme.spacing(3),
                display: "flex",
                alignItems: "left",
                justifyContent: "left",
                "& .dot": {
                  animation: "dot-blink 1s infinite step-start",
                },
                "& .dot:nth-of-type(1)": {
                  animationDelay: "0s",
                },
                "& .dot:nth-of-type(2)": {
                  animationDelay: "0.1s",
                },
                "& .dot:nth-of-type(3)": {
                  animationDelay: "0.2s",
                },
                "@keyframes dot-blink": {
                  "0%, 20%, 100%": {
                    opacity: 0,
                  },
                  "40%": {
                    opacity: 1,
                  },
                },
              }}
            >
              Processing
              <Box className="dot">.</Box>
              <Box className="dot">.</Box>
              <Box className="dot">.</Box>
            </Typography>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
